<template lang="pug">
  #app
    Header
    main.main
      transition(name="slide-fade" mode="out-in")
        router-view
    Footer
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="postcss">

@font-face {
    font-family: 'Peugeot';
    src: url('../public/assets/fonts/Peugeot.woff2') format('woff2'),
        url('../public/assets/fonts/Peugeot.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Peugeot';
    src: url('../public/assets/fonts/Peugeot-Light.woff2') format('woff2'),
        url('../public/assets/fonts/Peugeot-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'Peugeot';
    src: url('../public/assets/fonts/Peugeot-Bold.woff2') format('woff2'),
        url('../public/assets/fonts/Peugeot-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}

@import url("https://fonts.googleapis.com/css?family=Merriweather|Open+Sans");

*,
*:before,
*:after {
  box-sizing: border-box;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-kerning: auto;
}

html {
  -webkit-text-size-adjust: 100%;
}

body {
  font-family: "Merriweather", serif;
  margin: 0;
}

a,
area,
button,
[role="button"],
input:not([type=range]),
label,
select,
summary,
textarea {
  -ms-touch-action: manipulation;
      touch-action: manipulation;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

a {
  text-decoration: none;
  color: #b10925;
  -webkit-text-decoration-skip: objects;
}

a,
.text-transition,
.animate-all {
  transition: all 0.3s ease;
}

a:hover {
  color: #b10925;
  text-decoration: none;
}

a,
a:active,
a:focus {
  outline: none;
}

h1 [class^="ltpicto-"].small,
h2 [class^="ltpicto-"].small,
h3 [class^="ltpicto-"].small {
  font-size: 90%;
}
.sans-serif {
  font-family: "Open Sans", sans-serif;
}

cite {
  font-size: 80%;
  font-weight: 100;
}

dfn {
  font-style: italic;
  font-size: 90%;
}

blockquote {
  border-left: 5px solid #1b3043;
  background-color: #dedede;
  color: #1b3043;
  margin: 20px 0px;
}

img{
  max-width: 100%;
  border-style: none;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
}

input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

#app {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(12, 1fr);
  height: 100%;
  grid-template-rows: 143px auto auto;
  grid-template-areas:
    "h h h h h h h h h h h h"
    "c c c c c c c c c c c c"
    "f f f f f f f f f f f f";
  @media screen and (max-width: 900px){
    grid-template-rows: 44px auto auto;
  }
}


.header{
  grid-area: h;
}

.navigation{

}

.main{
  grid-area: c;
  margin: 0 0.8rem;
  background-color: #080808;
  background: linear-gradient(#080808 60%, #151515);
  padding: 1rem 0;
  min-height: 70vh;
  border: 2px solid red;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.footer {
  grid-area: f;
}

p {
  font-size: 1em;
  font-weight: 300;
}

h1 {
  font-size: 2.222rem;
  font-weight: 700;
}
h2 {
  font-size: 1.889rem;
  font-weight: 700;
}
h3 {
  font-size: 1.444rem;
  font-weight: 700;
}
h4 {
  font-size: 0.889rem;
  font-weight: 700;
}
h5 {
  font-size: 0.778rem;
  font-weight: 400;
}
h6 {
  font-size: 0.667rem;
  font-weight: 300;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to{
  transform: translateX(60px);
  opacity: 0;
}

.modaltransition-enter-active{
  transition: all .6s ease;
}

.modaltransition-leave-active {
  transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.modaltransition-enter, .modaltransition-leave-to{
  transform: translateY(60px);
  opacity: 0;
}

body .v--modal-overlay {
  background: rgba(0,0,0,0.9);
}

body{
  background: black;
  color: white;
  font-family: 'Peugeot', sans-serif;
}

</style>
